import { atom, selector } from 'recoil'

export const companyInfoState = atom({
  key: 'companyInfoState',
  default: {},
})

export const companyInfoSelector = selector({
  key: 'companyInfoSelector',
  get: ({ get }) => get(companyInfoState),
})
